/**
 * Zod schemas for Sub-Module plugin configuration (target module reference) and execution data (completion status).
 */
import { z } from "zod";
/**
 * Maximum allowed nesting depth for sub-modules.
 * Prevents accidental deep nesting and improves performance.
 */
export const MAX_NESTING_DEPTH = 10;
/**
 * Display modes for rendering nested module content.
 */
export const displayModes = ["inline", "expanded"];
/**
 * Configuration schema for the sub-module action type.
 * Admins configure which module to embed as a nested workflow.
 */
export const configSchema = z.object({
    /** UUID of the module to embed as a sub-module */
    targetModuleId: z.string().uuid("Must be a valid module ID"),
    /** How to display the nested module content */
    displayMode: z.enum(displayModes).default("expanded"),
});
/**
 * Data schema for the sub-module action type.
 * Tracks completion status of the nested module's actions.
 */
export const dataSchema = z.object({
    /** Number of actions completed in the nested module */
    completedActions: z.number().int().nonnegative(),
    /** Total number of required actions in the nested module */
    totalRequiredActions: z.number().int().nonnegative(),
    /** Whether all required actions are complete */
    isComplete: z.boolean(),
});
/**
 * Default configuration for new sub-module actions.
 * Note: targetModuleId must be set by admin before the action is usable.
 */
export const defaultConfig = {
    targetModuleId: "",
    displayMode: "expanded",
};
//# sourceMappingURL=schema.js.map